import {FC} from "react";
import Table from "../../ui/Table";
import {IFlow} from "../../../types/ApiTypes";
import {FaPen, FaTrash} from "react-icons/fa";

interface Props {
    flows: IFlow[];
    editSelected: (url: string) => void;
    deleteSelected: (url: string) => void;
}

const FlowList: FC<Props> = (props) => {
    const onEditSelected = (url: string) => {
        props.editSelected(url);
    }

    const onDeleteSelected = (url: string) => {
        props.deleteSelected(url);
    }

    const shortenUrl = (url: string) => {
        if(url.length > 46) return url.substring(0,46)+'...';
        return url;
    }

    return (
        <Table.Skeleton>
            <Table.THead>
                <Table.HeadTR>
                    <Table.TH>Flow URL</Table.TH>
                    <Table.TH>Flow Name</Table.TH>
                </Table.HeadTR>
            </Table.THead>
            <Table.TBody>
                {props.flows.length > 0 ? (
                    props.flows.map(x => (
                        <Table.BodyTR key={x.url}>
                            <Table.TD>{shortenUrl(x.url)}</Table.TD>
                            <Table.TD className='flex justify-between items-center'>
                                <span>{x.name}</span>
                                <div className='flex gap-2'>
                                    <FaTrash className='cursor-pointer text-error-brighter' onClick={() => onDeleteSelected(x.url)}/>
                                    <FaPen className='cursor-pointer' onClick={() => onEditSelected(x.url)}/>
                                </div>
                            </Table.TD>
                        </Table.BodyTR>
                    ))
                ) : (
                    <Table.BodyTR>
                        <Table.TD colspan={2}>Keine Flows verfügbar</Table.TD>
                    </Table.BodyTR>
                )}
            </Table.TBody>
        </Table.Skeleton>
    );
};

export default FlowList;